module.exports = __webpack_public_path__ + "static/media/ecos_stuttgart_3.ee7dab69.jpg";